// app.component.ts
import { Component, effect, inject, signal, Signal } from '@angular/core';

import { CommonModule } from '@angular/common';
import { User, UserService } from './services/user.service';
import { RouterOutlet } from '@angular/router'; // Импортируем RouterOutlet

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent {
}